export const WEBSITE_LEAD_INTERCEPTOR_COPY = {
  productName: "Website Lead Interceptor",

  // Settings page (/dashboard/integrations/web-widget)
  settingsSubtitle:
    "Embed the Website Lead Interceptor on your website and route leads to your AI employee.",
  settingsSaved: "Website Lead Interceptor settings saved.",
  activeLabel: "Website Lead Interceptor active",
  loadSettingsError: "Failed to load Website Lead Interceptor settings.",
  saveSettingsError: "Failed to save Website Lead Interceptor settings.",

  // Chats page (/dashboard/chat-web)
  chatsPageTitle: "Website Lead Interceptor Chats",
  chatsSubtitle: "Leads captured via the Website Lead Interceptor",
  loadChatsError: "Failed to load Website Lead Interceptor chats",
  chatsEmpty: "No Website Lead Interceptor chats yet",

  // GHL help text
  ghlLeadsSynced:
    "Website Lead Interceptor leads are synced to GHL automatically when a visitor",
  ghlChatsIncluded: "including Website Lead Interceptor chats when GHL is connected.",

  googleAdsSectionTitle: "Google Ads tracking",
  googleAdsConversionIdLabel: "Google Ads Conversion ID",
  googleAdsConversionIdHelp:
    "Install Google tag (gtag) on your website. The widget fires a conversion when a visitor successfully submits the intro form.",
  googleAdsConversionIdInvalid:
    "Google Ads Conversion ID must look like AW-123456789/AbCdEfGhIj",

  deliverySectionTitle: "Reply delivery",
  deliverySectionHelp:
    "Choose where the AI reply goes after a visitor submits the intro form.",
  deliveryModeWidget: "Standard (widget)",
  deliveryModeWidgetHelp: "Show the AI reply inside the chat widget on your website.",
  deliveryModeGhl: "GoHighLevel",
  deliveryModeGhlHelp:
    "Send each AI reply through GoHighLevel (SMS or Email). The widget shows a short confirmation instead of the full reply.",
  ghlChannelSms: "SMS",
  ghlChannelEmail: "Email",
  ghlPrerequisitesTitle: "GoHighLevel requirements",
  ghlPrerequisiteIntegration: "CRM integration active",
  ghlPrerequisitePipeline: "Pipeline and stage configured",
  ghlPrerequisiteEmailField: "Required email custom field (for Email channel)",
  ghlConfigureLink: "Configure GoHighLevel",
  ghlDeliveryViaGhlHint: "Replies are delivered via GoHighLevel, not in the widget chat bubble.",

  // Chats badge
  ghlDeliveryBadge: (channel) =>
    channel === "email" ? "GoHighLevel · Email" : "GoHighLevel · SMS",
  ghlDeliveryHint: "Reply delivered via GoHighLevel",

  // Landing
  realEstateIntegration:
    "Seamless connection to your WhatsApp / Telegram or Website Lead Interceptor.",
};
